import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Selecting an external bank account for your settlements?',
  description:
    'If you settle your daily takings to a Zeller Transaction Account, you’ll receive nightly settlements 7 days a week, 365 days a year, plus a range of additional benefits including:',
  benefit1: 'No account fees or charges',
  benefit2: 'Unlimited, free business Debit Cards and Accounts',
  benefit3: 'BSB and Account Number',
  benefit4: 'Fast and free real-time fund transfers',
  benefit5: 'Xero integration',
  benefit6: 'Change your settlement account with a click',
  warning:
    'Settlements to 3rd-party bank accounts will arrive the following business day.',
})
